import classNames from 'classnames'
import React, { CSSProperties } from 'react'
import styles from './Columns.module.css'

export const Columns = ({
    children,
    extraStyles,
    className
}: {
    children: React.ReactNode
    extraStyles?: CSSProperties
    className?: string
}) => {
    return (
        <div className={classNames(styles.root, className)} style={extraStyles}>
            {children}
        </div>
    )
}
